import * as React from 'react';
import Link from 'next/link';
import clsx from 'clsx';

import { getThemeCss } from 'components/Themes';

import styles from './Breadcrumbs.module.css';
import { BookingWidgetThemeContext } from 'contexts/BookingWidgetThemeContext';
import { getThemeCssOverride } from 'components/Themes';

interface ParentLink {
  text: string;
  href: string;
}

interface Props {
  pageTitle: string;

  parentLinks: ParentLink[];
}

export const Breadcrumbs = ({ pageTitle, parentLinks }: Props) => {
  const bookingWidgetTheme = React.useContext(BookingWidgetThemeContext);

  return (
    <ul
      className={clsx(
        styles['c-breadcrumbs'],
        'subcolor-bg',
        getThemeCssOverride(bookingWidgetTheme, 'c-breadcrumbs')
      )}
    >
      {parentLinks.map((parentLink) => (
        <li key={parentLink.href}>
          <Link
            href={parentLink.href}
            className={clsx('maincolor-txt', getThemeCss(bookingWidgetTheme, 'breadcrumb-link'))}
          >
            {parentLink.text}
          </Link>
        </li>
      ))}

      <li>{pageTitle}</li>
    </ul>
  );
};
